export function convertDateFormat(originalDate) {
  const [day, month, year] = originalDate.split(".");
  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
}

export function removeWordIfExists(inputString, word) {
  if (!inputString) return "";
  const regex = new RegExp(`${word}\\s*`, "g");
  return inputString.replace(regex, "");
}
